// extracted by mini-css-extract-plugin
export default {"menuContent":"ServicesTab--menuContent--928ea7"};